export function getLuggageConditions(value: string): string[] {
  return value.split('/').map(condition => condition.trim());
}

export function getLuggageMatchNumberByCondition(condition: string): RegExpMatchArray {
  return condition.match(/\d+/);
}
